import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { TranslationService, NotificationService, PagedResultGeneric, DatagridService } from 'src/app/shared';
import { ConfirmationService, MenuItem, SelectItem } from 'primeng/api';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { NewsArticleSearchDto } from '../shared/dto/news-article-search.dto';
import { NewsArticleDto } from '../shared/dto/news-article.dto';
import { NewsArticleService } from '../shared/news-article.service';
import { NewsArticleEditDialogComponent } from '../news-article-edit-dialog/news-article-edit-dialog.component';

@Component({
  selector: 'wl-news-articles-search-grid',
  templateUrl: './news-articles-search-grid.component.html',
  styleUrls: ['./news-articles-search-grid.component.less'],
    standalone: false
})
export class NewsArticlesSearchGridComponent extends LazySelectableTableComponent<NewsArticleSearchDto, NewsArticleDto> implements OnInit {
  pagingSizeItems: SelectItem[] = [];
  rowMenuItems = new Map<number, MenuItem[]>();

  @ViewChild(NewsArticleEditDialogComponent) editDialog: NewsArticleEditDialogComponent;

  loading: boolean;
  constructor(
    datagridService: DatagridService,
    private _translationService: TranslationService,
    private _newsArticleService: NewsArticleService,
    private _notificationService: NotificationService,
    private _navigationService: NavigationService,
    private _confirmationService: ConfirmationService
  ) {
    super('ArticleId', datagridService);
  }

  async ngOnInit(): Promise<void> {
    this.pagingSizeItems = [
      {
        label: await this._translationService.getTitlecase('common.page-size.show-20'),
        value: 20,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-100'),
        value: 100,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-all'),
        value: 9999,
      },
    ];
  }

  fetchResults(): Promise<PagedResultGeneric<NewsArticleDto>> {
    return this._newsArticleService.search(this.searchParams);
  }

  clear() {
    this.searchParams = new NewsArticleSearchDto();
    this.search();
  }

  actionItemsForNewsArticle(newsArticle: NewsArticleDto): MenuItem[] {
    if (!this.rowMenuItems.has(newsArticle.ArticleId)) {
      this.rowMenuItems.set(newsArticle.ArticleId, [
        {
          label: this._translationService.getInstantTitlecase('common.edit'),
          command: () => this.editNewsArticle(newsArticle),
        },
        {
          label: this._translationService.getInstantTitlecase('common.delete'),
          command: () => this.deleteNewsArticle(newsArticle),
        },
      ]);
    }
    return this.rowMenuItems.get(newsArticle.ArticleId);
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  private editNewsArticle(newsArticle: NewsArticleDto) {
    this.editDialog.open(newsArticle.ArticleId);
  }

  private deleteNewsArticle(newsArticle: NewsArticleDto) {
    this._confirmationService.confirm({
      key: 'deleteArticleCD',
      accept: () => {
        this.loading = true;
        this._newsArticleService.delete(newsArticle.ArticleId).then(
          () => {
            this._notificationService.translateSuccess('news-articles.delete.article-deleted');
            this.search();
          },
          (error) => {
            this._notificationService.httpError(error);
          }
        );
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
